/**
 * A function to create a singleton that manages the JWT access token in memory, including refreshing it.
 * 
 * @returns {{(token: string) => void, () => string | null, () => Promise<boolean>}} An object containing set, get, and refresh methods.
 */
function createTokenManager() {
    let accessToken = null;

    const setToken = (token) => { accessToken = token };
    const getToken = () => accessToken;

    const refresh = async () => {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}/auth/jwt/refresh/`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "include" 
        });

        if (response.ok) {
            const data = await response.json();
            setToken(data.access)
            return true;
        }
        return false;
    };

    return { setToken, getToken, refresh };
}

const TokenManager = createTokenManager();

export default TokenManager;